import { Modal, Paper, Slide } from '@material-ui/core'
import { useEffect, useState } from 'react'

import { getDirection } from '../../localization'
import ProgressComponent from './ProgressComponent'
import useStyles from './styles'

type AdotelSkeletonProps = {
  open: boolean
  numberOfCircles: number
  circlesColor: string
}

export default function AdotelSkeleton({
  open,
  numberOfCircles,
  circlesColor
}: AdotelSkeletonProps) {
  const classes = useStyles()
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)

  useEffect(() => {
    if (open) {
      setIsOpenModal(true)
    } else {
      setIsOpenModal(false)
    }
  }, [open])

  const onCloseModal = () => {
    setIsOpenModal(false)
  }

  return (
    <div className={classes.modalContainer}>
      <Modal dir={getDirection()} open={isOpenModal} onClose={onCloseModal}>
        <Slide in={isOpenModal} direction="down">
          <Paper className={classes.paper}>
            <ProgressComponent
              numberOfCircles={numberOfCircles}
              circlesColor={circlesColor}
            />
          </Paper>
        </Slide>
      </Modal>
    </div>
  )
}
